export const ai = {
    headers: {
        index: 'Assistente IA',
        health: 'Saúde Financeira',
        healthHistory: 'Histórico do score',
        healthDetail: 'Detalhe da análise',
        tips: 'Plano de Ação',
        chat: 'Chat Financeiro',
        summary: 'Resumo do Mês',
    },
    hub: {
        apiKey: {
            title: 'API key opcional',
            badge: 'Não configurada',
            description: 'O app continua funcionando localmente. Configure só se quiser respostas e análises por IA.',
        },
        insightsTitle: 'Insights do mês',
        features: {
            chatTitle: 'Chat Financeiro',
            chatSubtitle: 'Pergunte sobre seus gastos, metas e orçamentos',
            summaryTitle: 'Resumo do Mês',
            summarySubtitle: 'Relatório narrativo com os destaques do período',
            tipsTitle: 'Plano de Ação',
            tipsSubtitle: '3 a 5 ações práticas para o seu mês',
        },
        health: {
            title: 'Saúde Financeira',
            analysesSaved_one: '{{count}} análise salva',
            analysesSaved_other: '{{count}} análises salvas',
            emptySubtitle: 'Score de 0 a 100 com análise',
            deltaThisMonth: '{{delta}} este mês',
            emptyDescription: 'Gere seu primeiro score e acompanhe a evolução das suas finanças mês a mês.',
        },
    },
    chat: {
        suggestions: {
            sideBusiness: 'Qual meu lucro com {{name}}?',
            receivables: 'Quem me deve?',
            financings: 'Quanto falta dos financiamentos?',
            loans: 'Quanto falta dos empréstimos?',
            financingsAndLoans: 'Quanto falta dos financiamentos e empréstimos?',
            whereSpent: 'Onde mais gastei este mês?',
            vsLastMonth: 'Gastei mais que no mês passado?',
            canSpend: 'Quanto ainda posso gastar?',
            budgets: 'Algum orçamento estourou?',
            profit: 'Qual meu lucro com…',
            savings: 'Como está minha poupança?',
            emergencyFund: 'Como está minha reserva de emergência?',
        },
        homePlaceholder: 'Pergunte ao Kontto sobre seu dinheiro…',
        profitPrefill: 'Qual meu lucro com ',
        emptyPrompt: 'Pergunte qualquer coisa sobre suas finanças',
        inputPlaceholder: 'Pergunte sobre suas finanças...',
        localAnswer: 'Resposta local — {{warning}}',
        noKeyHint: 'Sem IA configurada, eu respondo o básico. Estas perguntas eu respondo na hora:',
        noKeySetup: 'Configurar IA',
        errorFallback: 'Não consegui processar sua pergunta.',
        periods: {
            this_month: 'este mês',
            last_month: 'no mês passado',
            last_3_months: 'nos últimos 3 meses',
            last_6_months: 'nos últimos 6 meses',
            last_12_months: 'nos últimos 12 meses',
            this_year: 'este ano',
        },
        cards: {
            seeTransactions: 'Ver lançamentos',
            ranking: {
                title: 'Onde você mais gastou',
                answer: 'Você já gastou {{total}} {{period}}. O que mais pesou foi {{top}} ({{pct}}).',
                confirmedOnly: 'Só lançamentos confirmados. Pendentes e previstos ficam de fora.',
                more_one: '+ {{count}} categoria',
                more_other: '+ {{count}} categorias',
            },
            comparison: {
                title: 'Até o dia {{day}}, contra {{previousMonth}}',
                thisMonth: 'Este mês',
                answerMore: 'Até o dia {{day}} você gastou {{current}}, {{diff}} a mais ({{pct}}) que no mesmo período de {{previousMonth}}.',
                answerLess: 'Até o dia {{day}} você gastou {{current}}, {{diff}} a menos ({{pct}}) que no mesmo período de {{previousMonth}}.',
                answerSame: 'Até o dia {{day}} você gastou {{current}}, praticamente o mesmo que no mesmo período de {{previousMonth}}.',
                answerNoPrevious: 'Até o dia {{day}} você gastou {{current}}. Não há gastos no mesmo período de {{previousMonth}} para comparar.',
                whatChanged: 'O que mais mudou',
                confirmedOnly: 'Só lançamentos confirmados, nos dois meses.',
            },
            available: {
                title: 'Até o fim do mês',
                now: 'Disponível agora',
                incoming: 'Ainda entra',
                outgoing: 'Ainda sai',
                overdueIn: 'Vencido, a receber',
                overdueOut: 'Vencido, a pagar',
                projectedEnd: 'Deve sobrar',
                projectedShort: 'Deve faltar',
                perDay: '≈ {{amount}} por dia nos próximos {{days}} dias',
                reservedNote: '{{amount}} guardado em caixinhas não entra na conta',
                answer: 'Você tem {{available}} disponível. Contando o que ainda entra e sai até o fim do mês, inclusive o que já venceu, devem sobrar {{projectedEnd}}.',
                answerNegative: 'Você tem {{available}} disponível, mas com o que ainda sai até o fim do mês, inclusive o que já venceu, devem faltar {{projectedEnd}}.',
            },
            budgets: {
                title: 'Orçamentos do mês',
                of: '{{spent}} de {{limit}}',
                answerOver_one: '{{count}} orçamento passou do limite este mês.',
                answerOver_other: '{{count}} orçamentos passaram do limite este mês.',
                answerWithin: 'Todos os seus orçamentos estão dentro do limite este mês.',
            },
            receivables: {
                title: 'Quem me deve',
                total: 'Total a receber',
                when: 'Quando der',
                dueOn: 'Combinado para {{date}}',
                overdueOn: 'Atrasado desde {{date}}',
                more_one: '+ {{count}} pessoa',
                more_other: '+ {{count}} pessoas',
                answer_one: '{{count}} pessoa te deve {{total}}.',
                answer_other: '{{count}} pessoas te devem {{total}} no total.',
                answerOverdue_one: ' {{count}} já passou da data combinada.',
                answerOverdue_other: ' {{count}} já passaram da data combinada.',
            },
            financings: {
                title: 'Financiamentos',
                titleLoan: 'Empréstimos',
                titleBoth: 'Financiamentos e empréstimos',
                kindFinancing: 'Financiamento',
                kindLoan: 'Empréstimo',
                noun: {
                    financing_one: 'financiamento',
                    financing_other: 'financiamentos',
                    loan_one: 'empréstimo',
                    loan_other: 'empréstimos',
                    both: 'financiamentos e empréstimos',
                },
                monthly: 'Parcelas por mês',
                balance: 'Saldo devedor',
                progress: '{{paid}} de {{total}} parcelas pagas',
                next: 'Próxima em {{date}}',
                answer_one: 'Você tem 1 {{noun}} ativo, com parcela de {{monthly}} por mês. Faltam {{remaining}} parcelas.',
                answer_other: 'Você tem {{count}} {{noun}} ativos, somando {{monthly}} por mês em parcelas.',
            },
            overview: {
                title: 'Resumo de {{month}}',
                income: 'Receitas',
                expense: 'Despesas',
                result: 'Resultado do mês',
                available: 'Disponível agora',
                reservedNote: '{{amount}} guardado em caixinhas fica de fora',
                savings: 'Poupança',
                health: 'Saúde financeira',
                answer: 'Este é o resumo de {{month}}. Você tem {{available}} disponível, sem contar o que está guardado em caixinhas.',
            },
            net: {
                titleProfit: 'Lucro · {{label}}',
                titleLoss: 'Prejuízo · {{label}}',
                income: 'Receitas',
                expense: 'Despesas',
                monthly: 'Resultado mês a mês',
                answerProfit: 'Com {{label}}, {{period}}, você teve lucro de {{amount}}.',
                answerLoss: 'Com {{label}}, {{period}}, você teve prejuízo de {{amount}}.',
            },
            empty: {
                top_categories: 'Ainda não há gastos registrados neste período.',
                month_comparison: 'Ainda não há gastos este mês nem no mês passado para comparar.',
                available: 'Não consegui calcular o disponível agora.',
                budgets: 'Você ainda não tem orçamentos. Crie um em Orçamentos para acompanhar aqui.',
                net: 'Não encontrei lançamentos nessas categorias ou tags no período.',
                receivables: 'Ninguém te deve nada agora. Empréstimos a pessoas ficam em Quem me deve.',
                financings: 'Você não tem financiamentos nem empréstimos ativos.',
            },
        },
    },
    summary: {
        emptyPrompt: 'Gere um resumo narrativo do seu mês com os dados reais das suas finanças',
        generateButton: 'Gerar resumo do mês',
        regenerateButton: 'Atualizar resumo',
        generatingButton: 'Gerando resumo...',
        sourceLocal: 'Resumo local',
        sourceAi: 'Resumo gerado com IA',
        highlightsTitle: 'Destaques do mês',
        copyPromptButton: 'Copiar prompt enviado',
        errorFallback: 'Erro ao gerar resumo',
    },
    tips: {
        emptyPrompt: 'Puxe para baixo para montar um plano de ação com base no seu momento financeiro',
        loadingLabel: 'Montando plano de ação...',
        sourceLocal: 'Plano de ação local',
        sourceAi: 'Plano de ação gerado com IA',
        copyPromptButton: 'Copiar prompt enviado',
        errorFallback: 'Erro ao gerar dicas',
    },
    copy: {
        copied: 'Prompt copiado para a área de transferência.',
        shared: 'Cópia indisponível neste build. Abri o compartilhamento do sistema.',
        failed: 'Não foi possível copiar ou compartilhar o prompt.',
    },
    consent: {
        title: 'Análise com IA',
        subtitle: 'Para gerar respostas, o Kontto envia um resumo das suas finanças diretamente para a {{provider}}, sob os termos desse provedor. Isso só acontece com a sua autorização.',
        sharedTitle: 'O que é enviado',
        notSharedTitle: 'O que nunca sai do aparelho',
        shared: {
            totals: 'Totais de receita e despesa do mês e por categoria',
            indicators: 'Indicadores agregados (taxa de poupança, uso do cartão, reserva)',
            goalsBudgets: 'Metas e orçamentos ativos (nome, alvo e progresso)',
            categoryNames: 'Os nomes das suas categorias e tags, sem valores (no chat, pra entender perguntas como "lucro com o app")',
        },
        notShared: {
            descriptions: 'Descrições de lançamento e nomes de estabelecimentos — a não ser que você peça para a IA categorizar uma fatura, e o app pergunta antes',
            accounts: 'Nomes das contas e números de cartão',
            apiKey: 'Sua chave de API (fica só no aparelho)',
        },
        policyLink: 'Ler a política de privacidade',
        footnote: 'Você pode revogar essa autorização a qualquer momento em Configurações › Assistente IA.',
        decline: 'Agora não',
        accept: 'Concordar e continuar',
    },
    health: {
        kicker: 'Saúde financeira',
        deltaSuffix: 'este mês',
        evolutionHint: 'O gráfico de evolução aparece a partir da segunda análise.',
        sourceLocal: 'Análise local',
        sourceAi: 'Análise com IA',
        trackMonthly: 'Acompanhe a evolução mês a mês',
        copyPromptButton: 'Copiar prompt enviado',
        analyzingButton: 'Analisando...',
        refreshButton: 'Atualizar análise',
        analyzeButton: 'Analisar saúde financeira',
        analyzeError: 'Erro ao analisar',
        emptyTitle: 'Sua saúde financeira',
        emptyDescription:
            'Gere a primeira análise para receber um score de 0 a 100, ver os fatores que mais pesam e começar a acompanhar a evolução mês a mês.',
        range3m: '3M',
        range6m: '6M',
        range12m: '12M',
        rangeAll: 'Tudo',
        historyEmpty:
            'Nenhuma análise salva ainda. Gere uma análise na tela de Saúde Financeira para começar a montar seu histórico.',
        statCurrent: 'Atual',
        statBest: 'Melhor',
        statAverage: 'Média',
        curveHint: 'Faça pelo menos duas análises para ver a curva de evolução.',
        allAnalyses: 'Todas as análises',
        analyzedOn: 'Analisado em {{date}}',
        summaryCopied: 'Resumo copiado para a área de transferência.',
        summaryCopyFailed: 'Não foi possível copiar o resumo.',
        notFound: 'Análise não encontrada.',
        analyzedOnWithSource: 'Analisado em {{date}} · {{source}}',
        sourceLocalInline: 'análise local',
        sourceAiInline: 'análise com IA',
        deltaVsPrevious: 'vs. {{period}} ({{score}})',
        scoreComposition: 'Composição do score',
        analysisLabel: 'Análise',
        strengths: 'Pontos fortes',
        improvements: 'A melhorar',
        viewHistory: 'Ver histórico',
        copySummary: 'Copiar resumo',
        summaryHeading: 'Saúde Financeira — {{period}}',
        summaryScore: 'Score: {{score}}/100 ({{band}})',
        summaryStrengths: 'Pontos fortes:',
        summaryImprovements: 'A melhorar:',
        band: {
            excellent: 'Excelente',
            good: 'Boa',
            regular: 'Regular',
            fragile: 'Frágil',
        },
        delta: {
            zero: '0',
            none: '—',
            value: '{{sign}}{{value}}',
        },
        subScores: {
            savingsLabel: 'Poupança',
            savingsNoteEmpty: 'Sem receita registrada no período.',
            savingsNote: 'Taxa de poupança em {{rate}}% (referência: 20%).',
            emergencyLabel: 'Reserva',
            emergencyNoteEmpty: 'Sem reserva identificada.',
            emergencyNote: 'Cobre {{months}} meses de despesas (alvo: 3 a 6).',
            creditLabel: 'Dívidas',
            creditNoteEmpty: 'Sem uso de cartão de crédito.',
            creditNote: 'Uso do cartão em {{usage}}% do limite.',
            budgetLabel: 'Orçamento',
            budgetNoteEmpty: 'Sem orçamentos ativos no período.',
            budgetNote: '{{pct}}% dos orçamentos dentro do limite.',
            regularityLabel: 'Regularidade',
            regularityNote: 'Lançamentos em {{pct}}% dos dias do mês.',
            diversificationLabel: 'Fontes de renda',
            diversificationNoteEmpty: 'Nenhuma fonte de renda no período.',
            diversificationNote: '{{sources}} fonte(s) de renda registrada(s).',
        },
    },
    errors: {
        copyableIntro: 'Cole este conteúdo em um chat externo com IA:',
        noApiKey: 'Nenhuma API key foi configurada. O app pode gerar o resultado localmente e você pode copiar o prompt para usar em um chat externo.',
        consentRequired: 'Para usar a IA, é preciso autorizar o envio do resumo financeiro ao provedor. Enquanto isso, o app gera o resultado localmente.',
        invalidKeyGemini: 'A chave do Gemini parece inválida ou sem permissão para este modelo. O Google está desativando as chaves antigas (as que começam com "AIza") — se for o seu caso, gere uma nova no Google AI Studio e cole aqui.',
        invalidKeyGeminiMalformed: 'O Google recusou esta chave. Normalmente ela foi colada incompleta ou veio com um espaço junto — apague o campo, copie a chave inteira no Google AI Studio e cole de novo. Se persistir, gere uma chave nova.',
        invalidKeyOpenai: 'A chave da OpenAI parece inválida ou sem permissão para este modelo.',
        invalidKeyOpenrouter: 'A chave do OpenRouter parece inválida. Confira se ela foi colada inteira (começa com "sk-or-") ou gere uma nova em openrouter.ai.',
        noCreditsOpenrouter: 'A chave do OpenRouter é válida, mas a conta está sem créditos. Adicione créditos em openrouter.ai ou escolha um modelo gratuito (com ":free" no nome) no campo de modelo.',
        rateLimitGemini: 'O limite temporário do Gemini foi atingido. Isso é comum no free tier. Aguarde um pouco ou copie o prompt para usar fora do app.',
        rateLimitOpenai: 'O limite temporário da OpenAI foi atingido. Aguarde um pouco ou copie o prompt para usar fora do app.',
        rateLimitOpenrouter: 'O limite temporário do OpenRouter foi atingido — é comum nos modelos gratuitos. Aguarde um pouco ou troque de modelo.',
        timeout: 'A chamada para a IA demorou demais e foi interrompida. Você pode tentar de novo ou copiar o prompt.',
        modelUnavailable: 'O provedor aceitou a chave, mas não encontrou o modelo de IA para este projeto. Se a chave é recém-criada, espere alguns minutos e tente de novo; se persistir, gere uma nova no Google AI Studio.',
        modelUnavailableOpenrouter: 'O OpenRouter não encontrou esse modelo. Confira o ID exato em openrouter.ai/models — ou deixe o campo de modelo vazio para usar o padrão do app.',
        providerUnavailable: 'O servidor do provedor respondeu com erro. Costuma ser instabilidade momentânea — tente de novo em alguns minutos.',
        networkUnreachable: 'Não foi possível falar com o servidor do provedor — a chamada nem chegou lá. VPN, DNS privado, bloqueador de anúncios ou rede corporativa costumam derrubar esse endereço. Testar pelos dados móveis ajuda a confirmar.',
        connectionFailed: 'Não foi possível validar a conexão com a IA agora.',
        generic: 'Não foi possível completar a análise com IA agora. Você pode tentar novamente ou copiar o prompt para usar em um chat externo.',
        connectionUnknown: 'Erro desconhecido ao validar a conexão.',
    },
    local: {
        analysis: {
            intro: 'Sua saúde financeira local ficou em {{score}}/100 no período {{period}}.',
            savingsRate: 'A taxa de poupança está em {{rate}}%.',
            creditUsage: 'O uso agregado do cartão está em {{usage}}% do limite.',
            reserve: 'A reserva cobre cerca de {{months}} meses de despesas.',
            adjustBudget: 'O principal ajuste agora é recuperar a aderência aos orçamentos ativos.',
            adjustSavings: 'O principal ajuste agora é aumentar a poupança recorrente do mês.',
            balanced: 'O cenário está relativamente equilibrado, com espaço para refinar metas e consistência.',
        },
        strengths: {
            savings: 'Taxa de poupança em {{rate}}%, acima da referência de 20%.',
            budget: 'Você manteve {{pct}}% dos orçamentos ativos dentro do limite.',
            credit: 'Uso do cartão controlado em {{usage}}% do limite total.',
            reserve: 'Sua reserva cobre cerca de {{months}} meses de despesas.',
            topCategory: 'A maior categoria de gasto representa {{pct}}% das despesas do período.',
        },
        improvements: {
            savings: 'A taxa de poupança está em {{rate}}%; tente levar para pelo menos 10%.',
            credit: 'O uso do cartão está em {{usage}}% do limite, acima da zona confortável.',
            reserve: 'A reserva cobre {{months}} meses; o alvo mínimo é entre 3 e 6.',
            overBudget: '{{category}} estourou o orçamento em {{amount}}.',
            budgetAdherence: 'Só {{pct}}% dos orçamentos ativos ficaram dentro do planejado.',
        },
        tips: {
            savingsTitle: 'Reforce sua poupança mensal',
            savingsDescription: 'Sua taxa de poupança está em {{rate}}%. Tente separar pelo menos 10% da receita assim que o dinheiro entrar.',
            creditTitle: 'Diminua a pressão no cartão',
            creditDescription: 'O cartão está usando {{usage}}% do limite total. Reduzir compras no crédito ajuda a evitar novo aperto no próximo fechamento.',
            overBudgetTitle: 'Revise {{category}}',
            overBudgetDescription: '{{category}} passou do orçamento em {{amount}}. Vale ajustar o limite ou cortar esse grupo ainda neste mês.',
            reserveTitle: 'Aumente a reserva de emergência',
            reserveDescription: 'Hoje sua reserva cobre {{months}} meses de despesas. O mínimo saudável costuma ficar entre 3 e 6 meses.',
            subscriptionsTitle: 'Revise assinaturas recorrentes',
            subscriptionsDescription: 'As assinaturas equivalem a {{pct}}% da sua receita mensal. Pode haver cortes fáceis aqui.',
            consistencyTitle: 'Mantenha a consistência',
            consistencyDescription: 'Seu cenário atual está relativamente equilibrado. Continue registrando gastos com frequência e revise metas uma vez por mês.',
        },
        narrative: {
            incomeExpense: 'Em {{period}}, sua receita foi de {{income}} e seus gastos somaram {{expenses}}.',
            savingsAbove: 'Você poupou {{rate}}% da receita, acima da referência de 20%.',
            savingsBelow: 'A taxa de poupança ficou em {{rate}}%, abaixo dos 20% recomendados.',
            savingsNegative: 'Os gastos superaram a receita neste período.',
            topExpense: 'A maior despesa foi {{category}} com {{amount}} ({{pct}}% do total).',
            expensesTrend: 'Os gastos variaram {{change}} em relação ao mês anterior.',
            budgetAdherence: '{{pct}}% dos orçamentos ficaram dentro do planejado.',
        },
        highlights: {
            topIncrease: '{{category}} aumentou {{change}} vs mês anterior.',
            topDecrease: '{{category}} reduziu {{change}} vs mês anterior.',
            savingsAbove: 'Taxa de poupança em {{pct}}%, acima da meta.',
            savingsLow: 'Taxa de poupança de apenas {{pct}}%. Atenção!',
            reserveSolid: 'Reserva de emergência sólida: {{months}} meses.',
            reserveLow: 'Reserva cobre apenas {{months}} meses. Meta: 3-6.',
            overBudget_one: '{{count}} orçamento estourado neste mês.',
            overBudget_other: '{{count}} orçamentos estourados neste mês.',
            creditAlert: 'Uso do cartão em {{pct}}% do limite. Zona de alerta.',
        },
        chat: {
            noExpenses: 'Não encontrei despesas registradas neste período.',
            expenses: 'Total de despesas: {{total}}. Principais categorias: {{categories}}.',
            noIncome: 'Não encontrei receitas registradas neste período.',
            income: 'Receita total: {{total}}. Fontes: {{sources}}.',
            noCaixinhas: 'Você ainda não tem caixinhas.',
            caixinhaLine: '{{name}}: {{current}}',
            caixinhaLineWithTarget: '{{name}}: {{current}} de {{target}}',
            caixinhas: 'Você tem {{reserved}} reservado em caixinhas: {{lines}}.',
            reservedParenthetical: ' ({{reserved}} reservado em caixinhas)',
            balance: 'Você tem {{available}} disponível pra gastar{{reservedPart}}. Caixa total: {{cashTotal}}. Faltam {{days}} dia(s) para o fim do mês.',
            noSavingsData: 'Sem dados suficientes para calcular a taxa de poupança.',
            savings: 'Sua taxa de poupança está em {{rate}}%. {{note}}',
            savingsAbove: 'Acima da referência de 20%!',
            savingsBelow: 'A referência recomendada é de pelo menos 20%.',
            noCreditData: 'Não encontrei dados de cartão de crédito.',
            credit: 'O uso agregado dos cartões está em {{usage}}% do limite total. {{note}}',
            creditRisk: 'Atenção: acima de 70% é considerado zona de risco.',
            creditComfortable: 'Dentro de uma faixa confortável.',
            noBudgets: 'Nenhum orçamento ativo encontrado.',
            budget: 'Aderência aos orçamentos: {{pct}}%. {{note}}',
            budgetOver_one: '{{count}} categoria estourou o limite.',
            budgetOver_other: '{{count}} categorias estourou o limite.',
            budgetAllWithin: 'Todos dentro do planejado.',
            noReserveData: 'Sem dados para calcular a reserva de emergência.',
            reserve: 'Sua reserva cobre {{months}} meses de despesas. {{note}}',
            reserveAbove: 'Acima do mínimo recomendado de 3 meses.',
            reserveIdeal: 'O ideal é ter entre 3 e 6 meses.',
            noGoals: 'Nenhuma meta ativa encontrada.',
            goalLine: '{{name}}: {{pct}}% ({{current}} de {{target}})',
            goals: 'Metas ativas: {{lines}}.',
            subscriptions: 'O total de assinaturas/recorrentes é de {{total}}/mês{{incomePart}}.',
            subscriptionsIncomePart: ', representando {{pct}}% da receita',
            noSubscriptions: 'Não encontrei gastos recorrentes registrados.',
            noData: 'sem dados',
            fallback: 'Receita: {{income}}. Despesas: {{expenses}}. Caixa: {{cash}}. Poupança: {{savings}}. Score: {{score}}/100. Para perguntas mais detalhadas, configure uma API key nas configurações.',
        },
        insights: {
            topIncrease: '{{category}} subiu {{change}} vs mês anterior',
            topDecrease: '{{category}} caiu {{change}} vs mês anterior',
            overBudget: '{{category}} estourou o orçamento em {{amount}}',
            savingsAbove: 'Poupança em {{pct}}% — acima da meta',
            expensesOverIncome: 'Gastos superaram a receita em {{amount}} no mês',
            savingsLow: 'Poupança em apenas {{pct}}% — meta: 20%',
            creditAlert: 'Cartão usando {{usage}}% do limite',
            noActivity: 'Nenhuma movimentação registrada neste mês',
        },
    },
};
